import { render } from "./UdpIcon.component.html?vue&type=template&id=13d1a22e&scoped=true&ts=true&external"
import script from "./UdpIcon.component.ts?vue&type=script&lang=ts&external"
export * from "./UdpIcon.component.ts?vue&type=script&lang=ts&external"

import "./UdpIcon.component.scss?vue&type=style&index=0&id=13d1a22e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d1a22e"]])

export default __exports__